import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo, useCallback } from 'react';
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { DownCaratIcon } from 'foundations-assets';
import { getSectionTitle } from '../../../utils/getSectionTitle';
import { SelectOptionWithTooltip } from '../SelectOptionWithTooltip';
import { Text } from 'foundations-components/components/Text';
import { QUOTES_ACTION_SECTION_KEY } from '../../../sections/quotes/types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MAX_QUICK_ACTIONS_EXCLUDING_QUOTES = 4;
const ButtonContent = () => {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "text-tertiary-default",
      typography: "body-100",
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.settings.quickActions.addQuickAction"
        })
      })
    }), /*#__PURE__*/_jsx(DownCaratIcon, {
      alignWithText: true,
      color: "text-tertiary-default"
    })]
  });
};
export const AddQuickActions = ({
  actionKeys,
  selected,
  onSelectedPropertyChange
}) => {
  const isDisabled = useCallback(option => {
    const isSelected = selected.includes(option);
    if (isSelected) {
      return false;
    }
    if (selected.length < MAX_QUICK_ACTIONS_EXCLUDING_QUOTES) {
      return false;
    }

    // Can only add a 5th quick action if Quotes is one of them. Slack ref - https://hubspot.slack.com/archives/C08BNE7K9UM/p1751318018225689?thread_ts=1750455479.926049&cid=C08BNE7K9UM
    if (selected.length === MAX_QUICK_ACTIONS_EXCLUDING_QUOTES && (selected.includes(QUOTES_ACTION_SECTION_KEY) || option === QUOTES_ACTION_SECTION_KEY)) {
      return false;
    }
    return true;
  }, [selected]);
  const options = useMemo(() => {
    return actionKeys.map(option => ({
      text: getSectionTitle(option),
      value: option,
      disabled: isDisabled(option)
    }));
  }, [actionKeys, isDisabled]);
  const handleSelectedOptionChange = useCallback(event => {
    onSelectedPropertyChange(event.target.value.map(option => {
      return option.value;
    }));
  }, [onSelectedPropertyChange]);
  const MultipleSelectOption = _ref => {
    let {
        children,
        option
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(SelectOptionWithTooltip, Object.assign({
      option: option,
      tooltipMessage: isDisabled(option.value) ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'crmObjectBoardCard.settings.quickActions.disabledTooltip'
      }) : null
    }, rest, {
      children: children
    }));
  };
  return /*#__PURE__*/_jsx(Select, {
    marginBlock: "200",
    "data-test-id": "add-quick-action-select",
    anchorType: "button",
    buttonSize: "small",
    multi: true,
    caretRenderer: /*#__PURE__*/_jsx(_Fragment, {}),
    ButtonContent: ButtonContent,
    optionComponent: MultipleSelectOption,
    options: options,
    value: selected,
    onSelectedOptionChange: handleSelectedOptionChange,
    searchPlaceholder: I18n.text('crmObjectBoardCard.settings.quickActions.searchPlaceholder')
  });
};